import { c as _c } from "react/compiler-runtime";
import SlugifiedAuthorLink from "@/components/author/slugifiedAuthorLink";
import Image from "@/components/common/image/image";
import { ArticleData, GlossaryTermData } from "@/sanity/interfaces";
import imageUrl from "@/sanity/utilities/imageUrl";
import { PortableText } from "next-sanity";
interface IAuthorInfoProps {
  data: ArticleData | GlossaryTermData;
}
const AuthorInfo = props => {
  const $ = _c(22);
  const {
    data
  } = props;
  const {
    author
  } = data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      marks: {
        highlight: _temp
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const components = t0;
  let t1;
  if ($[1] !== author) {
    t1 = author?.photo?.asset && <Image src={imageUrl(author.photo.asset).width(128).url()} alt={author.name ?? ""} width={128} height={128} className="h-24 w-24 rounded-full border-4 border-[#009490] object-cover md:h-32 md:w-32 md:min-w-32" />;
    $[1] = author;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = author?.name ?? "";
  const t4 = author?._id ?? "";
  const t5 = author?.name;
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="text-xl font-semibold text-[#005472]">{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t6) {
    t7 = <SlugifiedAuthorLink name={t3} id={t4}>{t6}</SlugifiedAuthorLink>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = author?.role;
  let t9;
  if ($[11] !== t8) {
    t9 = <div className="mb-3 text-sm font-medium text-[#696B68]"><span>{t8}</span></div>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = author?.bio;
  let t11;
  if ($[13] !== t10) {
    t11 = <PortableText value={t10} components={components} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t7 || $[17] !== t9) {
    t12 = <div className="mt-6 md:mt-0">{t7}{t9}{t11}</div>;
    $[15] = t11;
    $[16] = t7;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t2) {
    t13 = <><div className="relative mt-8 rounded-md bg-[#F6F6F6] p-8 md:mt-0 md:flex md:items-start md:gap-8">{t2}{t12}</div></>;
    $[19] = t12;
    $[20] = t2;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
export default AuthorInfo;
function _temp(t0) {
  const {
    children
  } = t0;
  return <span className="font-semibold">{children}</span>;
}